import { Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ImgBox({
  onClick = null,
  src = "notfound",
  alt = "sample Alt",
  sx = {},
}) {
  return (
    <Stack className="customImgBox" onClick={onClick} sx={sx}>
      <img
        style={{ width: "100%", height: "100%", objectFit: "cover" , }}
        src={src}
        alt={alt}
      />
    </Stack>
  );
}
